export default __webpack_public_path__ + "static/media/p7-14.8797cc6e.png";